import documentsActions from "./documentsActions";

export default documentsActions;
